module.exports = __webpack_public_path__ + "static/media/department-of-transport.458eb48e.png";